
import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "DynamicScore",
})
export default class DynamicScore extends Vue {
  steps = [
    {
      interval: {
        min: 0,
        max: 14,
      },
      color: "green lighten-5",
    },
    {
      interval: {
        min: 14,
        max: 28,
      },
      color: "green lighten-4",
    },
    {
      interval: {
        min: 28,
        max: 42,
      },
      color: "green lighten-3",
    },
    {
      interval: {
        min: 42,
        max: 56,
      },
      color: "green lighten-2",
    },
    {
      interval: {
        min: 56,
        max: 70,
      },
      color: "green lighten-1",
    },
    {
      interval: {
        min: 70,
        max: 84,
      },
      color: "green darken-2",
    },
    {
      interval: {
        min: 84,
        max: 99,
      },
      color: "green darken-4",
    },
  ];
  max = 99;
  scores = [80, 60];
  groupScore = 50;

  /**
   * Return css style for step
   * @param step
   */
  getStepStyle(step: Record<string, any>): string {
    return `left: ${this.getPercentage(step.interval.min)}%;
          width: ${this.getPercentage(
            step.interval.max - step.interval.min
          )}%;`;
  }

  /**
   * Return proportional percentage from interval
   * @param value
   */
  getPercentage(value: number): number {
    return (value * 100) / this.max;
  }

  data(): any {
    return {
      score_group: 68,
      score_avg: 70,
      score_max_indiv: 98,
    };
  }

  checkGroupFeedback(e: event, name: string): any {
    if (name == "pinIndiv") {
      this.score_max_indiv = e.target.value;
      if (this.score_max_indiv <= this.score_avg) {
        this.score_avg = Number(this.score_max_indiv) - 2;
      }
    } else if (name == "pinAvg") {
      this.score_avg = e.target.value;
      if (this.score_max_indiv <= this.score_avg) {
        this.score_max_indiv = Number(this.score_avg) + 2;
      }
    } else if (name == "pinGrp") {
      this.score_group = e.target.value;
    }

    if (
      this.score_group < this.score_max_indiv &&
      this.score_group < this.score_avg
    ) {
      const p = document.getElementById("texteSituation");
      p.className = "textSituationC-nul"; // remplace l’ancienne
      p.textContent =
        "Le groupe fait moins bien que la moyenne des membres du groupe.";
      const div = document.getElementById("divContainerId");
      div.style.borderColor = "#EB4E68";
    } else if (
      this.score_group < this.score_max_indiv &&
      this.score_group > this.score_avg
    ) {
      const p = document.getElementById("texteSituation");
      p.className = "textSituationC-moy"; // remplace l’ancienne
      p.textContent =
        "Le groupe fait mieux que la moyenne des membres du groupe.";
      const div = document.getElementById("divContainerId");
      div.style.borderColor = "#FFD523";
    } else if (
      this.score_group > this.score_max_indiv &&
      this.score_group > this.score_avg
    ) {
      const p = document.getElementById("texteSituation");
      p.className = "textSituationC-bien"; // remplace l’ancienne
      p.textContent = "Le groupe fait mieux que tous les membres du groupe.";
      const div = document.getElementById("divContainerId");
      div.style.borderColor = "#54BAA0";
    }
  }

  checkThumb(e: MouseEvent) {
    const el = e.target as HTMLInputElement;
    const rect = el.getBoundingClientRect();

    const min = Number(el.min);
    const max = Number(el.max);
    const value = Number(el.value);

    const percent = (value - min) / (max - min);
    const thumbX = rect.left + percent * rect.width;

    const distance = Math.abs(e.clientX - thumbX);
    const thumbSize = 20;

    if (distance > thumbSize) {
      e.preventDefault();
    }
  }
}
